import { DefaultArticleInsertProcessor } from './default-article-insert.processor';
import { CompositeMultipleBaseArticleInsertProcessor } from './composite-multiple-base-article-insert.processor';
import { CoverLabelStripArticleInsertProcessor } from './cover-label-strip-article-insert.processor';
import { ArticleInsertProcessorRegistry } from './article-insert-processor-registry';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ArticleInsertProcessorRegistryInitializer {
  constructor(
    private articleInsertProcessorRegistry: ArticleInsertProcessorRegistry,
    private defaultInsertProcessor: DefaultArticleInsertProcessor,
    private compositeMultipleBaseInsertProcessor: CompositeMultipleBaseArticleInsertProcessor,
    private coverLabelStripArticleInsertProcessor: CoverLabelStripArticleInsertProcessor
  ) {}

  public initialize() {
    this.articleInsertProcessorRegistry.initialize(this.defaultInsertProcessor, this.compositeMultipleBaseInsertProcessor, this.coverLabelStripArticleInsertProcessor);
  }
}
